import { ViewOption } from "types/viewOptions";

interface AdListViewSelectorProps {
    viewType: ViewOption;
    onViewChange: (view: ViewOption) => void;
}

const VIEW_OPTIONS: { value: ViewOption; label: string }[] = [
    { value: ViewOption.GRID, label: 'Kartlar' },
    { value: ViewOption.LIST, label: 'Liste' },
];

export default function AdListViewSelector({ viewType, onViewChange }: AdListViewSelectorProps) {
    return (
        <div className="sb-list-toolbar__control">
            <span id="viewSelectLabel" className="sb-list-toolbar__label">Görünüm:</span>
            <div className="sb-segmented sb-segmented--outline" role="group" aria-labelledby="viewSelectLabel">
                {VIEW_OPTIONS.map(({ value, label }) => {
                    const selected = viewType === value;
                    return (
                        <button
                            key={value}
                            type="button"
                            className={`sb-segmented__option${selected ? ' sb-segmented__option--active' : ''}`}
                            aria-pressed={selected}
                            onClick={() => onViewChange(value)}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    )
}
